import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Theme,
  IconButton,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import EditIcon from "@material-ui/icons/Edit";
import {
  getUniquMachineNumbers,
  getUniqueNames,
  getUniqueTypes,
  convertToBoolean,
  RETRIEVE_FROM,
} from "../constants/constants";
import { EventEmitter } from "../events/EventEmitter";
import { EquipmentsService } from "../services/EquipmentsService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import RetrieveOptionsDialog from "./RetrieveOptionsDialog";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    formControl: {
      margin: theme.spacing(3),
    },
  });
const inputTypes = [
  {
    value: "TEXT",
    label: "Text",
  },
  {
    value: "DATE",
    label: "Date",
  },
  {
    value: "TIME",
    label: "Time",
  },
  {
    value: "NUMBER",
    label: "Number (Digits only)",
  },
  {
    value: "IDENTITY NUMBER",
    label: "Identity Number(13 digits no space)",
  },
  {
    value: "PASSPORT NUMBER",
    label: "Passport Number",
  },
  {
    value: "PHONE NUMBER",
    label: "Phone Number (10 digits no space)",
  },
  {
    value: "EMAIL ADDRESS",
    label: "Email Address",
  },
  {
    value: "SIGNATURE",
    label: "Signature",
  },
];

const RETRIEVE_LINCENSE_VALUE = [
  {
    value: "licenseNumber",
    label: "License Number",
  },
  {
    value: "issuedDate",
    label: "Issued Date",
  },
  {
    value: "expiryDate",
    label: "Expiry Date",
  },
  {
    value: "authorizedEquipment",
    label: "Authorized Equipment",
  },
];

interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  defaultValue?: any;
  handleOnSubmit: any;
  headerData: any;
  companyData?: any;
  otherHeaders?: any;
}

class ItemHeaderDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    type: "",
    title: "",
    captureRetrieveOptions: false,
    companyData: false,
    equipmentData: false,
    customData: false,
    selectedItem: "",
    equipmentSelectedRetrievalOption: "",
    equipmentNameSelected: "",
    equipmentTypeNameSelected: "",
    customDataItems: Array<any>(),
    customDataValue: { value: "", label: "" },
    equipments: Array<any>(),
    uniqueNames: Array<any>(),
    uniqueTypes: Array<any>(),
    uniqueMachineNumbers: Array<any>(),
    results: {
      retriveOptionFrom: "",
      retrieveElement: "",
      secondaryRetriveElement: "",
      retrieveItems: Array<any>(),
      filterBy: "",
    },
  };

  componentDidMount = async () => {
    this.setDefaultValues();
  };
  componentDidUpdate = async (prevProps: any) => {
    if (
      prevProps.headerData.retrieveDetails !==
      this.props.headerData.retrieveDetails
    ) {
      this.setDefaultValues();
    }
  };

  getEquipmentsByCompanyId = (companyId: String) => {
    let equipmentsService: EquipmentsService = new EquipmentsService();
    EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
    equipmentsService.getEquipmentByCompanyId(companyId).then((resp) => {
      EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
      if (resp && resp.success && resp.equipments) {
        this.setState({
          equipments: resp.equipments,
          uniqueNames: getUniqueNames(resp.equipments),
          uniqueTypes: getUniqueTypes(resp.equipments),
          uniqueMachineNumbers: getUniquMachineNumbers(resp.equipments),
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  setDefaultValues = () => {
    const { headerData, companyData } = this.props;
    let values: any = this.state;
    if (
      headerData.retrieveDetails &&
      headerData.retrieveDetails.retriveOptionFrom
    ) {
      if (headerData.retrieveDetails.retriveOptionFrom === "customData") {
        values.customData = true;
        values.companyData = false;
        values.equipmentData = false;
      }
      if (headerData.retrieveDetails.retriveOptionFrom === "companyData") {
        values.companyData = true;
        values.customData = false;
        values.equipmentData = false;
      }
      if (headerData.retrieveDetails.retriveOptionFrom === "equipmentData") {
        values.companyData = false;
        values.companyData = false;
        values.equipmentData = true;
      }
      values.results.retriveOptionFrom =
        headerData.retrieveDetails.retriveOptionFrom;
      if (headerData.retrieveDetails.retrieveItems) {
        values.customDataItems = headerData.retrieveDetails.retrieveItems;
        values.results.retrieveItems = headerData.retrieveDetails.retrieveItems;
      }
      if (headerData.retrieveDetails.retrieveElement) {
        values.selectedItem =
          headerData.retrieveDetails.retriveOptionFrom === "companyData"
            ? headerData.retrieveDetails.retrieveElement
            : "";
        values.equipmentSelectedRetrievalOption =
          headerData.retrieveDetails.retriveOptionFrom === "equipmentData"
            ? headerData.retrieveDetails.retrieveElement
            : "";
        values.results.retrieveElement =
          headerData.retrieveDetails.retrieveElement;
      }
      if (headerData.retrieveDetails.secondaryRetriveElement) {
        values.results.secondaryRetriveElement =
          headerData.retrieveDetails.secondaryRetriveElement;
        values.equipmentNameSelected =
          headerData.retrieveDetails.secondaryRetriveElement;
        values.equipmentTypeNameSelected =
          headerData.retrieveDetails.secondaryRetriveElement;
      }
      if (headerData.retrieveDetails.filterBy) {
        values.results.filterBy = headerData.retrieveDetails.filterBy;
      }
    }
    this.setState(
      {
        title: headerData.title,
        companyData: values.companyData,
        equipmentData: values.equipmentData,
        customData: values.customData,
        selectedItem: values.selectedItem,
        equipmentSelectedRetrievalOption:
          values.equipmentSelectedRetrievalOption,
        equipmentNameSelected: values.equipmentNameSelected,
        equipmentTypeNameSelected: values.equipmentTypeNameSelected,
        customDataItems: values.customDataItems,
        results: {
          retriveOptionFrom: values.results.retriveOptionFrom,
          retrieveElement: values.results.retrieveElement,
          secondaryRetriveElement: values.results.secondaryRetriveElement,
          retrieveItems: values.results.retrieveItems,
          filterBy: values.results.filterBy,
        },
      },
      () => {
        if (companyData) {
          this.getEquipmentsByCompanyId(companyData._id);
        }
      }
    );
  };

  onCustomDataAddClicked = () => {
    if (this.state.customDataValue) {
      let currentCustomDataItems = this.state.customDataItems;
      currentCustomDataItems.push(this.state.customDataValue);
      this.setState({
        customDataItems: currentCustomDataItems,
        customDataValue: { value: "", label: "" },
      });
    }
  };

  handleRemoveCustomDataChip = (item: any, index: any) => {
    let items = [...this.state.customDataItems];
    items.splice(index, 1);
    this.setState({
      customDataItems: items,
    });
  };

  handleOnSubmit = () => {
    let results = this.state.results;
    results.retrieveItems = this.state.customDataItems;
    this.setState({
      results: results,
      captureRetrieveOptions: false,
    });
  };

  handleClose = () => {
    const { headerData } = this.props;
    if (headerData) {
      this.setState(
        {
          captureRetrieveOptions: false,
        },
        () => {
          this.setDefaultValues();
        }
      );
    } else {
      this.setState({
        captureRetrieveOptions: false,
        companyData: false,
        equipmentData: false,
        customData: false,
        selectedItem: "",
        customDataItems: Array<any>(),
        customDataValue: { value: "", label: "" },
        results: {
          retriveOptionFrom: "",
          retrieveElement: "",
          retrieveItems: Array<any>(),
        },
      });
    }
  };

  rendeCaptureRetrieveDialog = () => {
    const { headerData } = this.props;
    return (
      <RetrieveOptionsDialog
        dialogTitle={"Retrive Options"}
        onClose={() => {
          this.setState({
            captureRetrieveOptions: false,
          });
        }}
        retrieveDetails={
          headerData && headerData.title ? this.state.results : {}
        }
        uniqueMachineNumbers={this.state.uniqueMachineNumbers}
        uniqueNames={this.state.uniqueNames}
        uniqueTypes={this.state.uniqueTypes}
        equipments={this.state.equipments}
        open={this.state.captureRetrieveOptions}
        companyData={this.props.companyData}
        otherHeaders={this.props.otherHeaders}
        headerTitle={this.state.title}
        onSubmit={(results: any) => {
          this.setState({
            captureRetrieveOptions: false,
            results: results,
          });
        }}
      />
    );
  };
  render() {
    const {
      title,
      open,
      handleClose,
      handleOnSubmit,
      defaultValue,
      headerData,
    } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
          <Divider />
          <DialogContent>
            <Formik
              initialValues={
                headerData && headerData.title
                  ? headerData
                  : {
                      title: defaultValue ? defaultValue : "",
                      visibleToParent: false,
                      inherit: false,
                      retrieve: "",
                      retrieveDetails: {
                        retriveOptionFrom: "",
                        retrieveElement: "",
                        secondaryRetriveElement: "",
                        retrieveItems: Array<any>(),
                      },
                      licenseDetail: "",
                      type: "",
                      who: "",
                      fullNameRequired: false,
                    }
              }
              enableReinitialize={true}
              onSubmit={(values, { resetForm }) => {
                if (values.retrieve) {
                  values.retrieveDetails = this.state.results;
                }
                let mValue = { ...values };
                handleOnSubmit(mValue);
                resetForm();
                this.handleClose();
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                setFieldValue,
                isValid,
              }) => {
                return (
                  <Form>
                    <div>
                      <TextField
                        style={{ margin: 10 }}
                        id={"title"}
                        value={values.title}
                        onChange={(event) => {
                          this.setState(
                            {
                              title: event?.target.value,
                            },
                            () => {
                              handleChange(event);
                            }
                          );
                        }}
                        onBlur={handleBlur}
                        name={"title"}
                        disabled={defaultValue ? true : false}
                        label={"Title"}
                        fullWidth
                      />
                      <FormControlLabel
                        label="Visible to Parent"
                        control={
                          <Checkbox
                            id={"visibleToParent"}
                            name={"visibleToParent"}
                            style={{ marginLeft: 10 }}
                            checked={convertToBoolean(values.visibleToParent)}
                            onChange={(event: any) => {
                              setFieldValue(
                                "visibleToParent",
                                event.target.checked
                              );
                            }}
                            value="Visible to Parent"
                          />
                        }
                      />
                      <FormControlLabel
                        label="Inherit"
                        control={
                          <Checkbox
                            id={"inherit"}
                            name={"inherit"}
                            style={{ marginLeft: 10 }}
                            checked={convertToBoolean(values.inherit)}
                            onChange={(event: any) => {
                              setFieldValue("inherit", event.target.checked);
                            }}
                            value="Inherit"
                          />
                        }
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <TextField
                          style={{ margin: 10 }}
                          select
                          id={"retrieve"}
                          label={"Correspond to:"}
                          helperText={
                            "Select the field that correspond to this field in the Employee data."
                          }
                          margin="dense"
                          value={values.retrieve ? values.retrieve : ""}
                          onChange={(event: any) => {
                            setFieldValue("retrieve", event.target.value);
                            if (event.target.value === "options") {
                              this.setState({
                                captureRetrieveOptions: true,
                              });
                            }
                          }}
                          fullWidth
                        >
                          {RETRIEVE_FROM.map((option: any) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                        {values.retrieve === "options" &&
                          headerData &&
                          headerData.title && (
                            <IconButton
                              style={{ width: 20, height: 20, margin: 10 }}
                              onClick={() =>
                                this.setState({
                                  captureRetrieveOptions: true,
                                })
                              }
                            >
                              <EditIcon
                                style={{
                                  width: 20,
                                  height: 20,
                                }}
                                fontSize={"default"}
                              />
                            </IconButton>
                          )}
                      </div>
                      {values.retrieve === "licenseDetails" && (
                        <TextField
                          style={{ margin: 10 }}
                          select
                          id={"licenseDetails"}
                          label={"Lincense value from:"}
                          helperText={
                            "Select the field that correspond to this field in the License data."
                          }
                          margin="dense"
                          value={
                            values.licenseDetail ? values.licenseDetail : ""
                          }
                          onChange={handleChange("licenseDetail")}
                          fullWidth
                        >
                          {RETRIEVE_LINCENSE_VALUE.map((option: any) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                      <TextField
                        style={{ margin: 10 }}
                        select
                        id={"type"}
                        label={"Input type"}
                        margin="dense"
                        value={values.type ? values.type : ""}
                        error={!values.type ? true : false}
                        helperText={
                          !values.type ? "Please enter input type" : ""
                        }
                        disabled={defaultValue ? true : false}
                        onChange={handleChange("type")}
                        fullWidth
                      >
                        {inputTypes.map((option: any) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      {defaultValue && (
                        <div>
                          <TextField
                            style={{ margin: 10 }}
                            id={"who"}
                            value={values.who}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name={"who"}
                            label={"Who"}
                            fullWidth
                          />
                          <FormControlLabel
                            style={{ margin: 1 }}
                            control={
                              <Checkbox
                                id={"fullNameRequired"}
                                name={"fullNameRequired"}
                                checked={values.fullNameRequired}
                                onChange={handleChange("fullNameRequired")}
                                value="fullNameRequired"
                              />
                            }
                            label="Full name required"
                          />
                        </div>
                      )}

                      <DialogActions>
                        <Button
                          onClick={() => {
                            handleClose();
                          }}
                        >
                          {"CANCEL"}
                        </Button>
                        <Button
                          type="submit"
                          disabled={!isValid || !values.type}
                        >
                          {"SAVE"}
                        </Button>
                      </DialogActions>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </DialogContent>
        </Dialog>
        {this.rendeCaptureRetrieveDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ItemHeaderDialog);
